import React, { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import { useDeposits } from "../../services/hooks/getApi.js";
import ShimmerLoader from "../utilComponents/shimmer.js";
import { useLocation } from "react-router-dom";
import instance from "../../services/endpoint.js";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import "../../styles/history.css";
import { FaArrowLeft } from "react-icons/fa";

const PartialWithdraws = () => {
  const location = useLocation();
  const depositId = location.state?.id;
  const [loading, setLoading] = useState(null);

  const { data, isLoading, refetch } = useDeposits();
  console.log("Data from useDeposits:", data);  



  //whole deposite object
  const depositData = data?.deposits?.find(deposit => deposit.id === depositId) || {};


  // old age returns history
  const oldAgeHistory = depositData?.withdrawals || [];

  console.log("old age History-------:", oldAgeHistory);

  useEffect(() => {
    document.title = "Order Returns | Bitstek Advisory";
  }, []);


  // sending withdraw request
  const withdrawReq = async (deposit_mode, returnAmount, id, depositedAmount, particularReturn, month, final, index=100) => {
    console.log("Withdraw request initiated with parameters:")
    setLoading(index);
    if (
        !deposit_mode ||
        !returnAmount ||
        !id ||
        !depositedAmount ||
        !particularReturn ||
        !month
      ) {
        toast.error("Missing required fields.");
        return;
      }
  
      const payload = {
        withdraw_mode: deposit_mode,
        amount: returnAmount,
        id: id,
        depositedAmount,
        particularReturn,
        month,
        final,
        isOldAge: depositData?.isOldAge || false,
        isPartialWithdraw: depositData?.withdrawPeriodSelected || false,
      };

      console.log("Payload for withdraw request:", payload);
  
      try {
        const response = await instance.post("/api/v1/withdraw/oldage-withdraw", payload);
        await refetch();
        Swal.fire({
          title: "Success",
          text: response.data.message,
          icon: "success",
          confirmButtonText: "OK",
        });
      } catch (error) {
        toast.error(
          error?.response?.data?.message || "Error sending withdraw request."
        );
        console.error("Withdraw request error:", error);
      } finally {
        setLoading(null);
      }
    };

  return (
    <div className="oldage-container">
      <h4 className="text-center text-primary mt-4">Returns</h4>
      <div className="history-table-container mt-4">
        <div className="flex justify-content-between align-items-center mb-3">
          <div>
            <h5 className="text-warning mb-3">
              <strong>Date:</strong>{" "}
              {depositData?.requestedAt
                ? new Date(depositData?.requestedAt).toLocaleDateString("en-GB")
                : "N/A"}
            </h5>

            <h5 className="text-warning mb-3">
              <strong>Deposite Amount:</strong> ₹{depositData?.amount}
            </h5>

            {depositData?.withdrawPeriodSelected ? (
              <h5 className="text-warning mb-3">
                <strong>Withdraw Period:</strong> {depositData?.withdrawPeriod}
              </h5>
            ) : null}

          </div>
          <div>
            <button
              className="btn btn-warning"
              onClick={() => window.history.back()}>
              <FaArrowLeft /> back
            </button>
          </div>
        </div>
        <Table responsive className="history-table">
          <thead className="history-table-head">
            <tr>
              <th className="history-th">Month</th>
              <th className="history-th">Returns</th>
              <th className="history-th">Payment Status</th>
              <th className="history-th">Withdraw</th>
            </tr>
          </thead>
          <tbody className="history-table-body">
            {oldAgeHistory.length > 0 ? (
              oldAgeHistory.map((deposit, index) => (
                <tr key={index} className="history-row">
                  <td className="history-td">{deposit?.month} month</td>
                  <td className="history-td">₹{deposit?.amount}</td>
                  <td className="history-td">
                    <span
                      className={`badge ${
                        deposit?.paymentstatus === "Completed"
                          ? "bg-success"
                          : deposit?.paymentstatus === "Pending"
                          ? "bg-warning text-dark"
                          : "bg-danger"
                      }`}>
                        {deposit?.paymentstatus}
                    </span>
                  </td>
                  <td className="history-td">
                    {!deposit?.completed && !deposit?.withdraw ? (
                      <button className="btn btn-secondary btn-sm" disabled>
                        Waiting
                      </button>
                    ) : deposit?.completed && !deposit?.withdraw ? (
                      <button
                        className="withdraw-btn btn-sm"
                         onClick={() =>
                           withdrawReq(
                             depositData?.deposit_mode,
                             deposit?.amount,
                             depositData?.id,
                             depositData?.amount,
                             deposit?.amount,
                             deposit?.month,
                             false,
                             index
                           )
                         }
                        disabled={isLoading}>
                        {loading === index ? "Submitting..." : "Withdraw"}
                      </button>
                    ) : (
                      <button className="btn btn-success btn-sm">Done</button>
                    )}
                  </td>
                </tr>
              ))
            ) : isLoading ? (
              <tr>
                <td className="history-td" colSpan="10">
                  <ShimmerLoader width="120%" height="30px" />
                </td>
              </tr>
            ) : (
              <tr>
                <td className="history-td" colSpan="10">
                  No returns found
                </td>
              </tr>
            )}
          </tbody>
          <tfoot className="history-table-foot">
            <tr>
              <td colSpan="3" className=" font-bold">
                Withdraw deposited Amount: ₹{depositData?.amount}
                {/*  */}
                 <span
                  className={`badge ${
                    depositData?.paymentStatus === "Completed"
                      ? "bg-success"
                      : depositData?.paymentStatus === "Pending"
                      ? "bg-warning text-dark"
                      : "bg-danger"
                  }`}
                  style={{ marginLeft: "15rem" }} // Added left margin
                  >
                  {depositData?.paymentStatus}
                </span>
              </td>
              <td>
                {depositData?.returnStatus === "Pending" &&
                !depositData?.withdraw ? (
                  <button className="btn btn-secondary btn-sm ms-10" disabled>
                    Waiting
                  </button>
                ) : depositData?.returnStatus === "Completed" &&
                  !depositData?.withdraw ? (
                  <button
                    className="withdraw-btn btn-sm ms-10"
                    onClick={() =>
                      withdrawReq(
                        depositData.deposit_mode,
                        depositData.amount,
                        depositData.id,
                        depositData.amount,
                        depositData.amount,
                        depositData.completedMonths,
                        true
                      )
                    }
                    disabled={isLoading}>
                    {loading === 100 ? "Submitting..." : "Withdraw"}
                  </button>
                ) : (
                  <button className="btn btn-success btn-sm">
                    Done
                  </button>
                )}
              </td>
            </tr>
          </tfoot>
        </Table>
      </div>
    </div>
  );
};

export default PartialWithdraws;
